import { useEffect, useState } from "react";

/**
 * A hook that manages a boolean state that automatically resets to false after a delay.
 *
 * @param initialValue The initial state of the visibility.
 * @param delay The delay in milliseconds before resetting to false.
 * @returns [isVisible, setVisible] A tuple with the state and a setter.
 */
export function useTimedVisibility(
    initialValue: boolean = false,
    delay: number = 5000,
): [boolean, (value: boolean) => void] {
    const [isVisible, setIsVisible] = useState<boolean>(initialValue);

    useEffect(() => {
        if (isVisible) {
            const timeout = setTimeout(() => {
                setIsVisible(false);
            }, delay);
            return () => clearTimeout(timeout);
        }
    }, [isVisible, delay]);

    return [isVisible, setIsVisible];
}
